/**
 * @param {object} serverModel
 */
function RequestAssigneeSummaryModel(serverModel) {

  const self = this;

  self.assigneeType = serverModel.assigneeType;
  self.id = serverModel.id;
  self.name = serverModel.name;
  self.isDisabled = serverModel.isDisabled;
  self.isGroupEmpty = serverModel.isGroupEmpty;
  self.isGroupContactActive = serverModel.isGroupContactActive;

  self.value = `${self.assigneeType}-${self.id}`;
}

export default RequestAssigneeSummaryModel;
